<div class="side-menu-container">
    <div class="side-menu">
        <section class="top-menu">
            <ul>
                <ng-template ngFor let-item [ngForOf]="topMenu">
                    <li (click)="selectMenu(item)" [ngClass]="{'selected' : item.isSelected}">
                        <div class="icon-container">
                            <i class="mdi {{item.icon}}"></i>
                        </div>
                        <div class="menu"><span>{{item.text}}</span></div>
                    </li>
                </ng-template>
            </ul>
        </section>
        <section class="bottom-menu">
            <ul>
                <ng-template ngFor let-item [ngForOf]="bottomMenu">
                    <li (click)="selectMenu(item)" [ngClass]="{'selected' : item.isSelected}">
                        <div class="icon-container">
                            <i class="mdi {{item.icon}}"></i>
                        </div>
                        <div class="menu"><span>{{item.text}}</span></div>
                    </li>
                </ng-template>
            </ul>
        </section>
    </div>
</div>